import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import {setBehaviourEvent} from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

class RegoLookupAnalytics {
    static openAction() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.open;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static submitRegoLookupForm() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.submit;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static openFromConfiguratorAction() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showRegoFromConfiguratorLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static closeAction() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.close;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static setStateAction(state) {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.setState;

        setBehaviourEvent({category, action, label: state});
        setFunnelyticsBehaviourEvent({category, action, label: state});
    }
    
    static setVehicleNotProvidedCommentAction(comment) {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.setVehicleNotProvidedComment;

        setBehaviourEvent({category, action, label: comment});
        setFunnelyticsBehaviourEvent({category, action, label: comment});
    }

    static setRegoAction(rego) {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.setRego;

        setBehaviourEvent({category, action, label: rego});
        setFunnelyticsBehaviourEvent({category, action, label: rego});
    }

    static setPostcodeAction(postcode) {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.setPostcode;

        setBehaviourEvent({category, action, label: postcode});
        setFunnelyticsBehaviourEvent({category, action, label: postcode});
    }

    static showConfirmationLayer() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showConfirmationLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static hideConfirmationLayer() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.hideConfirmationLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }
    
    static showVehicleNotProvidedLayer() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showVehicleNotProvidedLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static hideVehicleNotProvidedLayer() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.hideVehicleNotProvidedLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static postcodeInvalid() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.postcodeInvalid;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static registrationInvalid() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.registrationInvalid;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static registrationNotFound() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.registrationNotFound;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static showTyres() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showTyres;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static setTyres(tyres) {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.setTyres;

        setBehaviourEvent({category, action, label: tyres});
        setFunnelyticsBehaviourEvent({category, action, label: tyres});
    }

    static showConfirmButton() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showConfirmButton;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({category, action, label});
        setFunnelyticsBehaviourEvent({category, action, label});
    }

    static showInfoAction() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.showInfo;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static goToFormAction() {
        const category = GA_EVENTS.regoLookup.category;
        const action = GA_EVENTS.regoLookup.actions.goToForm;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
}

export default RegoLookupAnalytics;